import { render, staticRenderFns } from "./addIncentives.vue?vue&type=template&id=d45bdfbc&scoped=true&"
import script from "./addIncentives.vue?vue&type=script&lang=js&"
export * from "./addIncentives.vue?vue&type=script&lang=js&"
import style0 from "./addIncentives.vue?vue&type=style&index=0&id=d45bdfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45bdfbc",
  null
  
)

export default component.exports